"use strict";

var _slicedToArray = require("/Users/natebennett/Documents/Talus/Code/AdLib/adlib/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/Users/natebennett/Documents/Talus/Code/AdLib/adlib/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var library_ui_expander_1 = __importDefault(require("@talus-analytics/library.ui.expander"));

var InteractionTarget = styled_components_1.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  // start a new block context to capture margins\n  display: flow-root;\n"])));

var Dropdown = function Dropdown(_a) {
  var renderButton = _a.renderButton,
      children = _a.children,
      onOpen = _a.onOpen,
      onClose = _a.onClose,
      _a$hover = _a.hover,
      hover = _a$hover === void 0 ? false : _a$hover,
      _a$animDuration = _a.animDuration,
      animDuration = _a$animDuration === void 0 ? 250 : _a$animDuration,
      _a$expanderStyle = _a.expanderStyle,
      expanderStyle = _a$expanderStyle === void 0 ? {} : _a$expanderStyle,
      props = __rest(_a, ["renderButton", "children", "onOpen", "onClose", "hover", "animDuration", "expanderStyle"]);

  var _ref = (0, react_1.useState)(undefined),
      _ref2 = _slicedToArray(_ref, 2),
      open = _ref2[0],
      setOpen = _ref2[1]; // handle onOpen and onClose effects


  (0, react_1.useEffect)(function () {
    open === true && onOpen && onOpen();
    open === false && onClose && onClose();
  }, [open, onClose, onOpen]); // detect onBlur, set a no-time timer to close it next tick but cancel
  // the timer if one of the child elements got focus. taken from here:
  // https://reactjs.org/docs/accessibility.html#mouse-and-pointer-events
  // This approach handles closing the expander when the user clicks away
  // but also when the user navigates away using the keyboard.

  var blurTimeout;

  var onBlurHandler = function onBlurHandler() {
    blurTimeout = setTimeout(function () {
      setOpen(false);
    });
  };

  var onFocusHandler = function onFocusHandler() {
    clearTimeout(blurTimeout);
  }; // by default, clicking the button opens / closes the expander


  var mouseHandlers = {
    onClick: function onClick() {
      return setOpen(function (prev) {
        return !prev;
      });
    }
  };
  var hoverHandlers = {}; // if hover is true, only allow onClick events from the keyboard
  // (detected because the clientX and clientY are zero) and use
  // onMouseEnter and onMouseLeave to open / close the dropdown

  if (hover) {
    mouseHandlers = {
      onClick: function onClick(e) {
        if (e.clientX === 0 && e.clientY === 0) setOpen(function (prev) {
          return !prev;
        });
      }
    };
    hoverHandlers = {
      onMouseEnter: function onMouseEnter() {
        return setOpen(true);
      },
      onMouseLeave: function onMouseLeave() {
        return setOpen(false);
      }
    };
  } // render the renderButton render props function,
  // and clone it with the new props we need


  var buttonWithProps = react_1.default.cloneElement(Object.assign({}, renderButton(open !== null && open !== void 0 ? open : false, animDuration)), Object.assign(Object.assign(Object.assign({}, mouseHandlers), hoverHandlers), {
    'aria-expanded': open ? 'true' : 'false',
    'aria-haspopup': 'true'
  })); // check if we're being passed the right kind
  // of element in the render prop function

  if ( // standard react elements will have type as a string
  typeof buttonWithProps.type === 'string' && buttonWithProps.type !== 'button' || // styled components have type.target
  typeof buttonWithProps.type === 'object' && buttonWithProps.type.target !== 'button') {
    var type = typeof buttonWithProps.type === 'string' && buttonWithProps.type || typeof buttonWithProps.type === 'object' && buttonWithProps.type.target;
    throw new Error("renderButton render prop in dropdown " + "must render a button element for accessibility. " + "Element type found was ".concat(type, "."));
  }

  return react_1.default.createElement("div", {
    onFocus: onFocusHandler,
    onBlur: onBlurHandler
  }, buttonWithProps, react_1.default.createElement(library_ui_expander_1.default, Object.assign({}, props, {
    floating: true,
    style: expanderStyle
  }, {
    open: open,
    animDuration: animDuration
  }), react_1.default.createElement(InteractionTarget, Object.assign({}, hoverHandlers, {
    tabIndex: -1
  }), children)));
};

exports.default = Dropdown;